/**
 * Home Page Script - Type-Safe Version
 */
import { buildLoginRedirect, optionalAuthPage } from '../lib/page-runtime';
import type { CreateIssueRequest } from '../types/api';

(function() {
  'use strict';

  const pageData = window.__SKILLFAB_PAGE__;
  if (!pageData || pageData.name !== 'home') return;

  const requestAnchor = '/#request-skill';
  const loginRequestHref = buildLoginRedirect(requestAnchor);

  function updateSubmitSection(loggedIn: boolean) {
    const section = document.getElementById('submit-section');
    const loginPanel = document.getElementById('request-login-panel');
    if (section) section.style.display = loggedIn ? 'block' : 'none';
    if (loginPanel) loginPanel.style.display = loggedIn ? 'none' : 'block';
    document.querySelectorAll<HTMLAnchorElement>('[data-request-skill-link]').forEach(function(link) {
      link.href = loggedIn ? requestAnchor : loginRequestHref;
    });
  }

  async function submitIssue(e: Event) {
    e.preventDefault();
    const title = (document.getElementById('issue-title') as HTMLInputElement).value.trim();
    const description = (document.getElementById('issue-desc') as HTMLTextAreaElement).value.trim();
    const priority = (document.getElementById('issue-priority') as HTMLSelectElement).value as 'low' | 'medium' | 'high';
    const acceptanceCriteria = (document.getElementById('issue-ac') as HTMLTextAreaElement | null)?.value.trim() || '';

    if (!title || !description) return;

    const btn = document.getElementById('submit-btn') as HTMLButtonElement;
    btn.disabled = true;
    btn.innerHTML = '<i class="fas fa-spinner fa-spin mr-2"></i>Requesting...';

    try {
      const requestData: CreateIssueRequest = {
        title,
        description,
        priority,
        ...(acceptanceCriteria && { acceptance_criteria: acceptanceCriteria }),
      };

      const result = await window.HomePageData.createIssue(requestData);

      if (result.ok) {
        showToast('Skill request created!');
        (document.getElementById('issue-title') as HTMLInputElement).value = '';
        (document.getElementById('issue-desc') as HTMLTextAreaElement).value = '';
        (document.getElementById('issue-priority') as HTMLSelectElement).value = 'medium';
        const acceptanceEl = document.getElementById('issue-ac') as HTMLTextAreaElement | null;
        if (acceptanceEl) acceptanceEl.value = '';
        window.location.href = '/issues/' + result.data.id;
      } else {
        showToast(result.error || 'Submission failed', 'error');
      }
    } catch (err) {
      showToast('Network error', 'error');
    } finally {
      btn.disabled = false;
      btn.innerHTML = '<i class="fas fa-paper-plane mr-2"></i>Request Skill';
    }
  }

  optionalAuthPage({
    onAuth: function(ctx) { updateSubmitSection(ctx.loggedIn); },
    init: function(ctx) {
      updateSubmitSection(ctx.loggedIn);
      const form = document.querySelector('#submit-section form');
      if (form) {
        form.addEventListener('submit', submitIssue);
      }
    },
  });
})();
